<template>
  <div
    v-if="isAdvanceSetting"
    v-click-away="onClickAwayAway"
    class="wrap-heading-settings-popover"
    @click="onClickPopover">
    <div class="arrow"></div>
    <div class="d-flex align-items-center justify-content-between heading-wrapper">
      <div class="title">{{ item.name }}</div>
      <div class="icon-box" @click="$emit('onCloseAdvancedSetting')">
        <i class="icon icon-close cursor-pointer" />
      </div>
    </div>
    <div class="wrap-tab">
      <div :class="{ 'active-tab': activeTab === 0 }" class="wrap-first-tab" @click="switchTab(0)">
        <label class="label-action">Desktop & Laptop</label>
      </div>
      <div :class="{ 'active-tab': activeTab === 1 }" class="wrap-second-tab" @click="switchTab(1)">
        <label class="label-action">Tablet & Mobile</label>
      </div>
    </div>
    <TextExtraSettings
      :key="activeTab"
      :data-setting="dataSetting"
      :index="index"
      @edit-color-style="editColorStyle"
      @on-click-popover="onClickPopover"
      @on-change-data-setting="onChangeDataSetting" />
  </div>
</template>

<script>
import { cloneDeep } from '@/utils/common';
import TextExtraSettings from './/TextExtraSettings.vue';
import { mapMutations } from 'vuex';
import { mutations } from '@modules/editor-sidebar';
import { dropPresetValueStyle } from '../../constants/styleConstant';
import { $gfLeftSideBar } from '@/app/index';

export default {
  name: 'TextAdvancedSetting',
  components: {
    TextExtraSettings,
  },
  props: {
    item: {
      type: Object,
      default: () => {
        return {};
      },
    },
    index: {
      type: Number,
      default: -1,
    },
    isAdvanceSetting: {
      type: Boolean,
    },
  },
  emits: ['onCloseAdvancedSetting', 'clickAway', 'onChangeTextItem'],
  data: () => ({
    activeTab: 0, // 0 = Desktop & Laptop, 1 = Table & Mobile
  }),
  computed: {
    dataSetting() {
      if (this.activeTab === 0) {
        return cloneDeep({ ...this.item.value, ...this.item.value.screens.lg });
      } else {
        return cloneDeep({ ...this.item.value, ...this.item.value.screens.sm });
      }
    },
  },
  methods: {
    ...mapMutations('sidebar', {
      stepPreset: mutations.SET_STEP_PRESET,
    }),
    onClickAwayAway() {
      this.$emit('clickAway');
    },
    switchTab(id) {
      this.activeTab = id;
    },
    editColorStyle() {
      this.stepPreset({
        next: {
          type: dropPresetValueStyle.colorStyle,
          target: {},
        },
        prev: {
          type: dropPresetValueStyle.textStyle,
          target: this.item,
        },
      });
    },
    onChangeDataSetting(data) {
      const text = data.value;
      const indexItem = this.index;
      const changeFontSize = data.chaneFontSize;
      const key = this.item.key;

      const screensStyle = {
        fontSize: text.fontSize,
        decoration: text.decoration,
        fontColor: text.fontColor,
        fontStyle: text.fontStyle,
        fontWeight: text.fontWeight,
        letterSpacing: text.letterSpacing,
        lineHeight: text.lineHeight,
      };
      if (this.activeTab === 0) {
        text.screens.lg = text.screens.md = screensStyle;
      } else {
        text.screens.sm = text.screens.xs = screensStyle;
      }

      text.screens.lg.decoration =
        text.screens.md.decoration =
        text.screens.sm.decoration =
        text.screens.xs.decoration =
          screensStyle.decoration;
      text.screens.lg.fontColor =
        text.screens.md.fontColor =
        text.screens.sm.fontColor =
        text.screens.xs.fontColor =
          screensStyle.fontColor;
      text.screens.lg.letterSpacing =
        text.screens.md.letterSpacing =
        text.screens.sm.letterSpacing =
        text.screens.xs.letterSpacing =
          screensStyle.letterSpacing;
      text.screens.lg.fontStyle =
        text.screens.md.fontStyle =
        text.screens.sm.fontStyle =
        text.screens.xs.fontStyle =
          screensStyle.fontStyle;
      text.screens.lg.fontWeight =
        text.screens.md.fontWeight =
        text.screens.sm.fontWeight =
        text.screens.xs.fontWeight =
          screensStyle.fontWeight;

      this.$emit('onChangeTextItem', {
        text,
        key,
        indexItem,
        changeFontSize,
      });
    },
    onClickPopover() {
      $gfLeftSideBar().data('gfleftsidebar').onBackgroundIframe('backgroundAdv');
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/app/editor/scss/variables';
@import '@/core/themes/vendor/color';
@import '@/core/themes/vendor/variables';
@import '@/core/themes/vendor/mixins';
.wrap-heading-settings-popover {
  background: map-get($hybrid-shade-dark, '400');
  width: 274px;
  position: absolute;
  top: 200px;
  left: 305px;
  border-radius: $radius;
  -moz-border-radius: $radius;
  -webkit-border-radius: $radius;
  padding: 12px;
  color: map-get($text-dark-mode, 'low-contrast');
  font-size: 12px;

  @media screen and (max-height: 670px) {
    top: 160px;
  }

  @media screen and (max-width: 1300px) {
    left: 280px;
  }

  .arrow {
    background: map-get($hybrid-shade-dark, '400');
    left: -16px;
    top: 80px;
    position: absolute;
    width: 16px;
    height: 16px;
    /* Border */
    transform: translate(50%, -50%) rotate(45deg);
  }

  .heading-wrapper {
    padding-bottom: 8px;
  }

  .title {
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    color: map-get($text-dark-mode, 'high-contrast');
  }

  .cursor-pointer {
    cursor: pointer;
    font-size: 16px;
  }

  .wrap-tab {
    display: flex;
    margin-bottom: 8px;
    color: map-get($text-light-mode, 'low-contrast');

    .wrap-first-tab {
      flex: 1 1 auto;
    }

    .active-tab {
      color: map-get($text-dark-mode, 'high-contrast');
      border-bottom: 1px solid map-get($text-dark-mode, 'high-contrast');
    }

    .wrap-second-tab {
      flex: 1 1 auto;
    }

    .label-action {
      cursor: pointer;
      padding-top: 9px;
      padding-bottom: 8px;
      text-align: center;

      &:hover {
        color: map-get($hybrid-shade-light, '100');
      }
    }
  }
}
.icon-box {
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 3px;
  cursor: pointer;

  &:hover {
    background-color: map-get($hybrid-shade-dark, '200');
  }
}
</style>
